import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "sale-stock" }
const _hoisted_2 = { class: "stock-form" }
const _hoisted_3 = { class: "flex rel" }
const _hoisted_4 = { style: {"padding-top":"28px"} }
const _hoisted_5 = { class: "product-table-wrap" }
const _hoisted_6 = {
  class: "flex-ter-bwn",
  style: {"margin-bottom":"12px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_8 = { class: "flex-ter" }
const _hoisted_9 = { style: {"margin-right":"16px"} }
const _hoisted_10 = { class: "flex-center" }
const _hoisted_11 = { class: "columns-search-style" }
const _hoisted_12 = {
  key: 0,
  class: "border-style"
}
const _hoisted_13 = { class: "border-left-export" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "download-icon",
  alt: "",
  src: "https://static-s.theckb.com/BusinessMarket/icon/download-icon@3.x.png"
}, null, -1)
const _hoisted_15 = { class: "show-one-line" }
const _hoisted_16 = {
  key: 0,
  class: "flex-center"
}
const _hoisted_17 = { style: {"margin-right":"6px"} }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  style: {"color":"#F5222D"}
}
const _hoisted_20 = { class: "platform-inventory-style" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  class: "expand-icon",
  alt: "",
  src: "https://static-s.theckb.com/BusinessMarket/Client/expandIconStock.png"
}, null, -1)
const _hoisted_22 = { class: "pending-storage-style platform-inventory-style" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  class: "expand-icon close-icon",
  alt: "",
  src: "https://static-s.theckb.com/BusinessMarket/Client/expandIconStock.png"
}, null, -1)

import { t } from '@/plugins/i18n'
import { ref, toRaw, watch, computed, onMounted, nextTick, reactive } from 'vue'
import { cloneDeep, sum } from 'lodash'
import { clearForm, setDefaultForm, filterObjectKey, setNoEmptyForm } from '@/util/common'
import { isD2C, isJA, useSite2Station, isMultiStore, useRtfix } from '@/store'
import NewInputBatchSearch from '@/components/NewInputBatchSearch/index.vue'
import DragTableSearch from '../DragTableSearch/index.vue'
import { useStore } from 'vuex'
import { ShopType } from '@/common/const'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { d2cColumns, productTableConfig } from './SalesPerspectiveData'
import STable from '@/components/Table/index.vue'
import ShopInfoDrawer from './ShopInfoDrawer.vue'
import HeaderTips from '../HeaderTips.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import TableButton from '@/components/Table/TableButton.vue'
import { Edit, Select, QuestionFilled, WarningFilled } from '@element-plus/icons-vue'
import {
  getThirdShopItemPageQuery
} from '@/apis/stock'
import axios from 'axios'
import { exportFileDownload } from '@/util/useExport'
import { updateCustomerProductNo } from '@/apis/associated'
import { dayjs, ElMessage } from 'element-plus'
import { request } from '@/config/request/interceptors'

export default /*#__PURE__*/_defineComponent({
  props: ['form', 'isAmazon'],
  emits: ['update:form'],
  setup(__props, { emit: emits }) {

const props = __props
const showStockTip = ref(true)
const tooltipRef = ref()

const skuKeyDist: any = {
  color: t('颜色'),
  size: t('尺寸')
}

const productPageData = ref({
  page: 1,
  limit: 30
})

/** 2b 平台库存是否展开 */
const platformInventoryExpand = ref(false)

const handleShow = async (row: any) => {
  row.loading = true
  await shopInfoDrawerRef.value.show(row.thirdSkuCode)
  row.loading = false
}

/** 2b 平台库存点击是否展开 */
const clickPlatformInventoryExpand = () => {
  platformInventoryExpand.value = !(platformInventoryExpand.value)
}

/** d2c最终的columns */
const d2cLastProductColumns: any = ref(d2cColumns)
/** 筛选表格-确认选择 */
const handleOkSelectColumns = (data) => {
  if (isD2C()) {
    d2cLastProductColumns.value = []
    nextTick(() => {
      d2cLastProductColumns.value = data
    })
    tooltipRef.value.onClose()
    return
  }
  tooltipRef.value.onClose()
}
const refreshTime = ref('')
const dataListener = (data: any, apiData: any) => {
  if (productPageData.value.page === 1 && data[0]?.updateTime) {
    refreshTime.value = dayjs(data[0]?.updateTime).format('YYYY-MM-DD HH:mm')
  }
}

watch(() => platformInventoryExpand.value, () => {
  nextTick(() => {
    d2cLastProductColumns.value = d2cColumns.filter((i) => {
      return platformInventoryExpand.value || i.prop !== 'pendingStorage'
    })
  })
}, { immediate: true })

const exportProductLoading = ref(false)
const exportProduct = () => {
  exportProductLoading.value = true
  axios({
    method: 'post',
    url: process.env.VUE_APP_URL + '/api/thirdShopItem/export',
    responseType: 'blob',
    headers: {
      'X-AuthToken': store.getters.token,
      'X-AuthShopId': store.getters.curShop,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-stationCode': useSite2Station(),
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    },
    data: submitForm.value
  })
    .then((res: any) => {
      exportFileDownload(res, { name: '在庫視点‐自社SKU_' })
    })
    .finally(() => {
      exportProductLoading.value = false
    })
}

/** 刷新 */
const handleRefresh = async () => {
  const res = await request.apis.thirdShopItem.updateThirdSkuStock()
  if (res.success) {
    ElMessage.success('更新処理中です。しばらくしてからページを再読み込みしてください。')
  }
}

onMounted(() => {
  const PSearchTip = localStorage.getItem('PSearchTip')
  if (PSearchTip) {
    showStockTip.value = false
  }
})

const closeInput = (row: any) => {
  request.apis.thirdShopItem.updateStaticItemSkuRemark({
    /** 客样sku */
    itemRemark: row.itemRemark,
    /** 三方sku编码 */
    thirdSkuCode: row.thirdSkuCode
  }).then((res: any) => {
    if (res.success) {
      row.isExit = false
      ElMessage.success(t('番号保存成功'))
      refreshTable()
    }
  })
}

const store = useStore()
// const isCrossMall = computed(() => store.getters.isCrossMall)
const isTikTokShop = computed(() => store.getters.shopInfo?.customerShopPlatform === ShopType.TIKTOK)




const shopProductSkuType = ref(1)
const defaultForm = {
  skuBindingStatus: '',
  thirdItemName: '',
  notDeliverMax: '',
  notDeliverMin: '',
  pendingMax: '',
  pendingMin: '',
  waitReplenishMax: '',
  waitReplenishMin: ''

}
const getForm = (form: any) => setDefaultForm(cloneDeep(toRaw(form)), defaultForm)

const _form = ref(getForm(defaultForm))
const submitForm = ref<any>(cloneDeep(_form.value))

const searchForm = computed(() => {
  return setNoEmptyForm(submitForm.value)
})
const submit = () => {
  const realVal = getRealVal()
  submitForm.value = cloneDeep(_form.value)
  if (quantitySymbol.value && quantity.value! && submitForm.value.skuBindingStatus == '1') {
    if (quantityType.value === 'notDeliver') {
      submitForm.value.notDeliverMax = realVal[1]
      submitForm.value.notDeliverMin = realVal[0]
    }
    if (quantityType.value === 'pending') {
      submitForm.value.pendingMax = realVal[1]
      submitForm.value.pendingMin = realVal[0]
    }
    if (quantityType.value === 'waitReplenish') {
      submitForm.value.waitReplenishMin = realVal[0]
      submitForm.value.waitReplenishMax = realVal[1]
    }
  } else {
    submitForm.value.notDeliverMax = undefined
    submitForm.value.notDeliverMin = undefined
    submitForm.value.pendingMax = undefined
    submitForm.value.pendingMin = undefined
    submitForm.value.waitReplenishMin = undefined
    submitForm.value.waitReplenishMax = undefined
  }

  if (submitForm.value.itemRemarkList && !(submitForm.value.itemRemarkList instanceof Array)) {
    console.log(submitForm.value.itemRemarkList)
    submitForm.value.itemRemarkList = submitForm.value.itemRemarkList?.split('\n')
  }
  refreshTable(true)
}

const resetForm = () => {
  clearForm(_form.value)
  quantitySymbol.value = ''
  quantity.value = ''
  quantityType.value = ''
  //   需要都重置下
  _form.value.itemRemarkList = undefined
  submitForm.value = cloneDeep({ ...toRaw(_form.value) })
  refreshTable(true)
}

const quantityType = ref('notDeliver')
const quantitySymbol: any = ref(1)
const quantity: any = ref(1)

const clearQuantity = () => {
  _form.value.notDeliverMax = ''
  _form.value.notDeliverMin = ''
  _form.value.pendingMax = ''
  _form.value.pendingMin = ''
  _form.value.waitReplenishMin = ''
  _form.value.waitReplenishMax = ''
}

const getRealVal = () => {
  let val: any = []
  if (quantitySymbol.value === 1) {
    val = [quantity.value, 999999999]
  } else if (quantitySymbol.value === 2) {
    val = [quantity.value, quantity.value]
  } else if (quantitySymbol.value === 3) {
    val = [0, quantity.value]
  }
  return val
}

const d2cProductSnum: any = {
  notDeliver: t('未发货数量合计'),
  waitReplenish: t('可售良品数'),
  pending: t('处理中合计')
}

watch(() => quantityType.value, clearQuantity)

const refreshTable = (type?: boolean) => {
  if (type) {
    productPageData.value = {
      page: 1,
      limit: 30

    }
  }
  refreshProduct()
}

const productRef = ref()
const refreshProduct = () => {
  nextTick(() => {
    productRef.value && productRef.value.getData()
  })
}

onMounted(async () => {
  refreshTable(true)
})

const shopInfoDrawerRef = ref<any>(null)


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        inline: "",
        "label-width": "auto",
        "label-position": "top",
        model: _form.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _unref(t)('商品名')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _form.value.thirdItemName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_form.value.thirdItemName) = $event)),
                maxlength: "100",
                placeholder: _unref(t)('请输入'),
                style: {"margin-right":"4px","width":"100%"},
                class: "searchitem"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('客户商品sku')
          }, {
            default: _withCtx(() => [
              _createVNode(NewInputBatchSearch, {
                modelValue: _form.value.itemRemarkList,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_form.value.itemRemarkList) = $event)),
                placeholder: _unref(t)('双击批量搜索'),
                maxlength: "100",
                style: {"margin-right":"4px","width":"100%"},
                class: "searchitem"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('纽付状态')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _form.value.skuBindingStatus,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_form.value.skuBindingStatus) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(t)('全部'),
                    value: ''
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(t)('已绑定'),
                    value: 1
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(t)('未绑定'),
                    value: 0
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_form.value.skuBindingStatus == '1')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                class: "select-form",
                label: _unref(t)('可用库存数量筛选'),
                style: {"margin-right":"20px!important"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_select, {
                      modelValue: quantityType.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((quantityType).value = $event)),
                      style: { marginRight: '4px', maxWidth: '110px' }
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(d2cProductSnum, (label, value) => {
                          return _createVNode(_component_el_option, {
                            key: value,
                            label: label,
                            value: value
                          }, null, 8, ["label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_input, {
                      modelValue: quantity.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((quantity).value = $event)),
                      style: {"margin-right":"4px","flex":"1","width":"200px"}
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: quantitySymbol.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((quantitySymbol).value = $event)),
                          style: {"width":"80px"},
                          class: "prependSel"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: '≥',
                              value: 1
                            }),
                            _createVNode(_component_el_option, {
                              label: '=',
                              value: 2
                            }),
                            _createVNode(_component_el_option, {
                              label: '≤',
                              value: 3
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_form_item, { label: '' }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: submit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: resetForm }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(SvgIcon, { name: "History" }),
            _createTextVNode("更新日時：" + _toDisplayString(refreshTime.value) + " ", 1),
            _createVNode(_component_el_tag, {
              type: "primary",
              style: {
              '--el-color-primary': '#0586FE',
              '--el-tag-border-color': '#0586FE',
              'border-radius': '12px',
              'cursor': 'pointer',
            },
              effect: "plain",
              onClick: handleRefresh,
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('更新')), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_tooltip, {
            effect: "light",
            placement: "left",
            ref: (_value, _refs) => {
              _refs['tooltipRef'] = _value
              tooltipRef.value = _value
            }
          }, {
            content: _withCtx(() => [
              _createVNode(DragTableSearch, {
                productColumns: _unref(d2cColumns),
                selectedColumns: d2cLastProductColumns.value,
                onHandleOk: handleOkSelectColumns,
                onCancel: _cache[6] || (_cache[6] = ($event: any) => (tooltipRef.value.onClose()))
              }, null, 8, ["productColumns", "selectedColumns"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, [
                  _createVNode(SvgIcon, {
                    class: "wrap rel",
                    name: "sort"
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('表格筛选')), 1)
                ])
              ])
            ]),
            _: 1
          }, 512),
          (!_unref(isD2C)())
            ? (_openBlock(), _createElementBlock("div", _hoisted_12))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            class: "export-color-gray",
            style: {"font-size":"12px"},
            type: "text",
            loading: exportProductLoading.value,
            onClick: exportProduct
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_13, [
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_unref(t)("导出")), 1)
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(STable, {
          ref: (_value, _refs) => {
            _refs['productRef'] = _value
            productRef.value = _value
          },
          api: _unref(getThirdShopItemPageQuery),
          "page-data": productPageData.value,
          "onUpdate:page-data": _cache[7] || (_cache[7] = ($event: any) => ((productPageData).value = $event)),
          columns: d2cLastProductColumns.value,
          filterData: _unref(searchForm),
          tableConfig: _unref(productTableConfig),
          isImmediatelyExec: false,
          isClearSelection: false,
          maxHeight: "calc( 100vh - 350px)",
          showAllExpand: false,
          paginationConfig: { pageSizes: [10, 20, 30, 50, 100] },
          onDataListener: dataListener
        }, {
          productInfo: _withCtx(({ row }) => [
            _createElementVNode("div", null, [
              _createVNode(ShoppingPreview, {
                image: row.thirdItemImage || row.thirdItemImage || ''
              }, null, 8, ["image"]),
              _createVNode(_component_el_tooltip, { effect: "light" }, {
                content: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(row?.thirdItemName), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_15, _toDisplayString(row?.thirdItemName), 1)
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          itemRemark: _withCtx(({ row }) => [
            (!row.isExit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(row.itemRemark), 1),
                  _createVNode(_component_el_icon, {
                    style: {"cursor":"pointer"},
                    onClick: ($event: any) => (row.isExit = true)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Edit))
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : (_openBlock(), _createBlock(_component_el_input, {
                  key: 1,
                  modelValue: row.itemRemark,
                  "onUpdate:modelValue": ($event: any) => ((row.itemRemark) = $event),
                  maxlength: "100"
                }, {
                  suffix: _withCtx(() => [
                    _createVNode(_component_el_icon, {
                      style: {"cursor":"pointer"},
                      class: "el-input__icon",
                      onClick: ($event: any) => (closeInput(row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Select))
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"]))
          ]),
          thirdItemAttribute: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.thirdItemAttribute), 1)
          ]),
          bindStatus: _withCtx(({ row }) => [
            (row.bindStatus === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, "已纽付"))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, "未纽付"))
          ]),
          waitReplenishQuantityTitle: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("可用库存1")) + " ", 1),
            _createVNode(HeaderTips, { content: `現在倉庫にある良品数から、未発送点数を差し引いた数量を利用可能在庫として表示します。例：
良品数：100
未発送点数：150
処理中在庫：20
→ 利用可能在庫：―50
→ 必要購入数：30` })
          ]),
          pendingQuantityTitle: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createTextVNode(_toDisplayString(_unref(t)("处理中1")), 1),
              (!platformInventoryExpand.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "expand-style",
                    onClick: clickPlatformInventoryExpand
                  }, [
                    _hoisted_21,
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('展开1')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          hasDeliverQuantity: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.bindStatus === 1 ? row.hasDeliverQuantity : '-'), 1)
          ]),
          waitReplenishQuantity: _withCtx(({ row }) => [
            _createElementVNode("div", {
              style: _normalizeStyle({
              'color': row.waitReplenishQuantity < 0 ? 'red' : ''
            })
            }, _toDisplayString(row.bindStatus === 1 ? row.waitReplenishQuantity : '-'), 5)
          ]),
          notDeliverQuantity: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.bindStatus === 1 ? row.notDeliverQuantity : '-'), 1)
          ]),
          freezeQuantity: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.bindStatus === 1 ? row.freezeQuantity : '-'), 1)
          ]),
          pendingQuantity: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.bindStatus === 1 ? row.pendingQuantity : '-'), 1)
          ]),
          waitPurchaseQuantity: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.bindStatus === 1 ? row.waitPurchaseQuantity : '-'), 1)
          ]),
          purchasingQuantity: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.bindStatus === 1 ? row.purchasingQuantity : '-'), 1)
          ]),
          purchasedQuantity: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.bindStatus === 1 ? row.purchasedQuantity : '-'), 1)
          ]),
          expressQuantity: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.bindStatus === 1 ? row.expressQuantity : '-'), 1)
          ]),
          stockInQuantity: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.bindStatus === 1 ? row.stockInQuantity : '-'), 1)
          ]),
          checkingQuantity: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.bindStatus === 1 ? row.checkingQuantity : '-'), 1)
          ]),
          abnormalQuantity: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.bindStatus === 1 ? row.abnormalQuantity : '-'), 1)
          ]),
          unableDefectiveQuantity: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.bindStatus === 1 ? row.unableDefectiveQuantity : '-'), 1)
          ]),
          historyPurchasedQuantity: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.bindStatus === 1 ? row.historyPurchasedQuantity : '-'), 1)
          ]),
          pendingStorageHeadD2c: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _createTextVNode(_toDisplayString(_unref(t)("处理中明细")) + " ", 1),
              (platformInventoryExpand.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "expand-style",
                    style: {"top":"-5px"},
                    onClick: clickPlatformInventoryExpand
                  }, [
                    _hoisted_23,
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('收起')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          handler: _withCtx(({ scope }) => [
            _createVNode(TableButton, {
              title: "仕入れ情報を見る",
              disabled: !!scope.row.loading,
              loading: !!scope.row.loading,
              onClick: ($event: any) => (handleShow(scope.row))
            }, null, 8, ["disabled", "loading", "onClick"])
          ]),
          _: 1
        }, 8, ["api", "page-data", "columns", "filterData", "tableConfig"])
      ]),
      _createVNode(ShopInfoDrawer, {
        ref: (_value, _refs) => {
          _refs['shopInfoDrawerRef'] = _value
          shopInfoDrawerRef.value = _value
        }
      }, null, 512)
    ])
  ]))
}
}

})